import React, {Fragment} from 'react';

class InputRender extends React.Component {
	static defaultProps = {
		disabled: false,
		readOnly: false,
		className: '',
		addClassName: '',
		maxLength: 255
	};

	render() {
		const {id, input, placeholder, className, type, disabled, readOnly, maxLength, autoComplete, meta} = this.props;
		return (
			<Fragment>
				<input
					{...input}
					id={id}
					placeholder={placeholder}
					autoComplete={autoComplete}
					className={className}
					type={type}
					disabled={disabled}
					readOnly={readOnly}
					maxLength={maxLength === 0 ? 100000 : maxLength}
				/>
				{meta.error && meta.touched &&
					<div className='error text-danger'>{meta.error}</div>}
			</Fragment>
		);
	}
}

export default InputRender;



// WEBPACK FOOTER //
// ./src/common/fields/renders/InputRender.js